// extracted by mini-css-extract-plugin
export default {"banner":"OurTeam_banner__lG4Wq","content":"OurTeam_content__eIPcU","text":"OurTeam_text__BUTc3","image":"OurTeam_image__8oAqn"};